import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  noPreviewOverlay: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.ModalBGColor,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    zIndex: 100,
  },
  noPreviewText: {
    fontSize: theme.textFontSize,
    fontWeight: 500,
    backgroundColor: theme.gridOverlayBGColor,
    color: theme.gridOverlayFontColor,
    border: `1px solid ${theme.gridOverlayFontColor}`,
    padding: 10
  }
});

const NoPreview = ({ classes }) => (
  <div className={classes.noPreviewOverlay}>
    <div className={classes.noPreviewText}>No route preview available</div>
  </div>
);

export default withStyles(styles)(NoPreview);
